import React from 'react';

export default function ShopfrontBanner() {
  return (
    <section className="bg-[#E8EDE5] py-12 sm:py-16" data-testid="shopfront-banner">
      <div className="max-w-2xl mx-auto px-4 sm:px-8 text-center">
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-medium text-[#3A4035] tracking-tight leading-snug mb-4">
          You don't need a shopfront to build a successful practitioner business.
        </h2>
        <p className="text-base sm:text-lg text-[#1A1A1A]/70 leading-relaxed mb-3">
          The way people find and book practitioners has changed. A private studio opens up new possibilities.
        </p>
        <p className="text-sm sm:text-base text-[#1A1A1A]/60 leading-relaxed max-w-xl mx-auto">
          Whether you're starting your own business or bringing an established practice, Go Freestyle gives you your own professional studio, with less to manage and more time for the work you love.
        </p>
      </div>
    </section>
  );
}
